query GetLandingPageDomain {
    landingPageDomain
}
